var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgGridColumns = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7 11h16v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2Zm1 1v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-9Zm0-4v3h14V8ZM7 7h16v5H7Zm10 5h1v10h-1Zm-5 0h1v10h-1Z"
})));
export default SvgGridColumns;